import PropTypes from 'prop-types';
import NtaPaletteStatusVisual from '../components/NtaPaletteStatusVisual';
import { NTA_PALETTE_ICON } from './ntaInstructionsContent';

const NtaPaletteLegendIcon = ({ icon, count, size = 24 }) => (
  <NtaPaletteStatusVisual icon={icon} label={count} size={size} />
);

export default NtaPaletteLegendIcon;

NtaPaletteLegendIcon.propTypes = {
  icon: PropTypes.oneOf(Object.values(NTA_PALETTE_ICON)).isRequired,
  count: PropTypes.number,
  size: PropTypes.number
};
